module.exports = __webpack_public_path__ + "img/data-guaranteed.23dc2b9b.png";